/**
 * 登録が必須である読み替え可能なヘッダーの一覧
 * @param WarehouseNumber - 倉庫番号
 * @param SupplierNumber - 仕入先番号
 * @param BusinessNumber - 商品番号
 * @param Package - 容量
 * @param CustomerNumber - 売上先番号
 * @param SalesDestinationNumber - 送り先番号
 * @param InventoryValue - 在庫数量
 * @param SalesResultsValue - 販売実績数量
 * @param ArrivalValue - 入荷実績数量
 */
export const REQUIRE_ALTERABLE_HEADERS = [
  'WarehouseNumber',
  'SupplierNumber',
  'BusinessNumber',
  'Package',
  'CustomerNumber',
  'SalesDestinationNumber',
  'InventoryValue',
  'SalesResultsValue',
  'ArrivalValue',
  'OrderNumber',
  'EstimatedTimeOfArrival',
  'OrderAmount',
] as const;

// 未選択を示す文字列
export const UNSELECTED_HEADER_VALUE = 'UNSELECTED_HEADER_VALUE';
